import { Checkbox, Input, Page, Text } from "@geist-ui/core";
import React, { useEffect, useState } from "react";
import ValueItem from "../../../Components/ValueItem";
import { v4 as uuidv4 } from "uuid";
import HubspotForm from "react-hubspot-form";

import "./styles.css";
import axios from "axios";

function Question(props) {
  const {
    data,
    options,
    selectedValues,
    firstName,
    lastName,
    emailValue,
    onFirstChange,
    onLastChange,
    onEmailChange,
    onFormSubmit
  } = props;
  const [checked, setChecked] = useState([]);
  const [mountStyle, setMountStyle] = useState({
    opacity: 0,
    transition: "all 1s ease",
  });

  //console.log(mountStyle, data.question);

  useEffect(() => {
    setChecked(selectedValues);

    return null;
  }, [selectedValues]);

  useEffect(() => {
    setMountStyle({
      opacity: 1,
      transition: "all 1s ease",
    });

    return () => {
      setMountStyle({
        opacity: 0,
        transition: "all 1s ease",
      });
    };
  }, []);

  const handleOnChange = (val) => {
    //console.log(val, "this is the onChange EventValue");
    ////console.log(val, data.question, "IT AINT ME");
    setChecked(val);
    props.onChange(val);
  };

  /* const isDisabled = (val) => {
      //console.log(checked, selectedValues, 'checked Items & Selected Values')
    //It will return -1 if the item was not found in the checked array array.
    //It will also check if you've reached the max choice number
    return selectedValues.length === data.choiceLimit && selectedValues.indexOf(val) === -1;
  }; */

  const renderCheckboxes = () => {
    return options.map((item, index) => {
      //const key= uuidv4();
      const isDisabled =
        checked.length === data.choiceLimit && checked.indexOf(item) === -1;
      return <ValueItem key={data.uid} isDisabled={isDisabled} data={item} />;
    });
  };
  

  const renderContent = () => {
    //console.log(data, "this is the question data");
    //console.log(data.type);
    switch (data.type) {
      case "question":
        return (
          <div className="checkboxGroup">
            <Checkbox.Group value={selectedValues} onChange={handleOnChange}>
              {renderCheckboxes()}
            </Checkbox.Group>
          </div>
        );
      case "form":
        /* 
        
        <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/v2.js"></script>
<script>
  hbspt.forms.create({
    region: "na1",
    portalId: "22392178",
    formId: "95642f39-7d4a-4036-9dd4-61c731d8f0e1"
  });
</script>
        */


 /* 
        
        use HubSpot API to push to form without this clunky component
        https://www.devtwins.com/blog/hubspot-forms-react-submit-form-using-hubspot-api

        https://legacydocs.hubspot.com/docs/methods/forms/submit_form
        


        */

        


        return (
          <div className="inputContainer">
            {/* <HubspotForm
              // New Credentials
              //portalId="21744358"
              //formId="69da2649-a6b8-4031-bf27-bf8f23b55b48"
              // Old Credentials
              portalId="22392178"
              formId="95642f39-7d4a-4036-9dd4-61c731d8f0e1"
              onSubmit={onFormSubmit}
              onReady={(form) => console.log("Form ready!", form)}
              loading={<div>Loading...</div>}
            /> */}
            <input
              className={"nameInput"}
              value={firstName}
              onChange={onFirstChange}
              type={"text"}
              placeholder="First Name"
              width="100%"
            />
            <input
              className={"nameInput"}
              value={lastName}
              onChange={onLastChange}
              type={"text"}
              placeholder="Last Name"
              width="100%"
            />
            <input
              value={emailValue}
              onChange={onEmailChange}
              type={"email"}
              placeholder="Email"
              width="100%"
            />
          </div>
        );
      case "newSection":
      default:
        return null;
    }
  };

  return (
    <div id="question" style={mountStyle}>
      {renderContent()}
    </div>
  );
}

export default Question;
